export const SET_ACT_PROPERTY = 'SET_ACT_PROPERTY';
export const ACT_GET_ACT = 'ACT_GET_ACT';
export const SIGN_INIT_GUID = 'SIGN_INIT_GUID';
export const ACT_ERROR = 'ACT_ERROR';
export const ACT_CMS = 'ACT_CMS';
export const ACT_SAVE_DATA = 'ACT_SAVE_DATA';
export const ACT_CONFIRM_IDENTITY = 'ACT_CONFIRM_IDENTITY';
export const ACT_GET_CATALOG = 'ACT_GET_CATALOG';
export const UI_UPDATE_FROM_PARTNER = 'UI_UPDATE_FROM_PARTNER';
export const SET_ACT_CHECKLIST_ITEM = 'SET_ACT_CHECKLIST_ITEM';
export const SET_ACT_CHECKLIST_INTERNAL_BREAKS_ITEM = 'SET_ACT_CHECKLIST_INTERNAL_BREAKS_ITEM';
export const SET_ACT_CHECKLIST_EXTERNAL_BREAKS_ITEM = 'SET_ACT_CHECKLIST_EXTERNAL_BREAKS_ITEM';
export const DELETE_ACT_CHECKLIST_EXTERNAL_BREAKS_ITEM =
  'DELETE_ACT_CHECKLIST_EXTERNAL_BREAKS_ITEM';
export const SEND_SIGN = 'SEND_SIGN';
export const END_SIGN = 'END_SIGN';
export const CANCEL_ACT = 'CANCEL_ACT';
export const VALIDATE_DOCUMENT = 'VALIDATE_DOCUMENT';
export const GET_DOCUMENTS = 'GET_DOCUMENTS';
export const ACT_GET_CONCESSIONS = 'ACT_GET_CONCESSIONS';
export const ACT_SET_ANOTHER_DELIVERY = 'ACT_SET_ANOTHER_DELIVERY';
export const SET_ACT_CHECKLIST_ACCESSORIES = 'SET_ACT_CHECKLIST_ACCESSORIES';
export const GET_REQUIDED_DOCUMENTATION = 'GET_REQUIDED_DOCUMENTATION';
